export const REPLY_POLICY = {
  INSTAGRAM:
    'https://developers.facebook.com/docs/messenger-platform/policy/policy-overview#24hours_window?locale=pt_BR',
  FACEBOOK:
    'https://developers.facebook.com/docs/whatsapp/message-templates/guidelines?locale=pt_BR',
};
